export default __webpack_public_path__ + "static/media/Keyboard.86dc706a.svg";